// extracted by mini-css-extract-plugin
module.exports = {"short_quiz_results":"styles_short_quiz_results__2BO1m","short_quiz_results__export_btn":"styles_short_quiz_results__export_btn__1u3zU"};